import { EnvContext as UIEnvContext } from "@vimana/ui-components/dist/Components/Env/EnvContext";
import React, { useContext } from "react";

import { ApplicationPropertiesContext } from "./ApplicationPropertiesController";

export const EnvContext = ({ children }) => {
  const applicationProperties: any = useContext(ApplicationPropertiesContext);
  console.warn("APP version: ", applicationProperties.appVersion);
  return <UIEnvContext.Provider value={applicationProperties}>{children}</UIEnvContext.Provider>;
};
